import { t } from "@/i18n-js/instance";
import { formatPaywallCurrencyAmount } from "@/react/helpers/paywalls/currencies";
import { mapCurrencyAmountStrToInt } from "@circle-react/components/Paywalls/Admin/utils";
import { paywallPriceTypes } from "@circle-react/types/PaywallPrice";
import type {
  NoticeScenario,
  NoticeScenarioMatcher,
  NoticeScenarioMessagePropsResolver,
} from "../NoticeScenario.types";
import { localeRoot } from "../constants";
import { installmentsStateValidator } from "./StateValidators";

const matcher: NoticeScenarioMatcher = ({
  priceType,
  hasUpfrontPayment,
  hasTrialPeriod,
}) =>
  priceType === paywallPriceTypes.installments &&
  !hasUpfrontPayment &&
  !hasTrialPeriod;

const messagePropsResolver: NoticeScenarioMessagePropsResolver = ({
  currency,
  watch,
}) => {
  const totalAmount = mapCurrencyAmountStrToInt(watch("amount"));
  const installmentsCount = parseInt(watch("installments_count"));
  const installmentAmount = Math.round(totalAmount / installmentsCount);
  const intervalType = watch("billing_frequency");

  // Variables used in locale
  const installment_amount = formatPaywallCurrencyAmount(
    currency,
    installmentAmount,
  );
  const member_charged_immediately_phrase = t(
    [localeRoot, "phrases", "member_charged_immediately"],
    {
      amount: installment_amount,
    },
  );
  const total_amount_phrase = t([localeRoot, "phrases", "total_amount"], {
    amount: formatPaywallCurrencyAmount(currency, totalAmount),
  });

  if (installmentsCount === 1) {
    return [["onetime"], { member_charged_immediately_phrase }];
  }

  return [
    ["installments", intervalType],
    {
      count: installmentsCount - 1,
      member_charged_immediately_phrase,
      installment_amount,
      total_amount_phrase,
    },
  ];
};

export const installments: NoticeScenario = {
  matcher,
  stateValidator: installmentsStateValidator,
  messagePropsResolver,
};
